import React from 'react';
import ProductTile from './ProductTile';
import { createLCYourTitlesProductDetailLink } from './utils/product-detail-link-helpers';
import ListItem from './ListItem';
import { DISPLAY_TYPE_LIST, DisplayType } from '../../../shared/common/displayType/types';
import { ProductListItemProps } from '../../../shared/common/ProductList';

type Props = ProductListItemProps & { displayType: DisplayType };

const ProductElement = (props: Props) => {
    const productLinkUri = createLCYourTitlesProductDetailLink(props.product.id ?? '');
    if (props.displayType === DISPLAY_TYPE_LIST) {
        return (
            <ListItem
                isYourTitle={true}
                isLibxchange={false}
                isInCollection={false}
                productLinkUri={productLinkUri}
                product={props.product}
                shopLanguage={undefined}
            />
        );
    }

    return (
        <ProductTile
            isYourTitle={true}
            isLibxchange={false}
            isInCollection={false}
            productLinkUri={productLinkUri}
            product={props.product}
            minimalView={props.minimalView}
            shopLanguage={undefined}
        />
    );
};

export default ProductElement;
